export default __webpack_public_path__ + "static/media/affilate-logo.22f879ae.svg";